import { geographyTree } from '../../pages/admin/common/geographyPicker.js';

// The header's geography picker, from GET /player-segment/my-geographies: { wholeGame, geographies }.
//
// "Global (all players)" is offered only to a caller whose access covers the whole game. For a caller
// limited to geographies it grants nothing (their grants apply only once a geography is selected), so it
// is left out and their first geography is selected for them - otherwise every page would refuse them
// until they found the picker.
export const GLOBAL_VALUE = 'global';
export const GLOBAL_ITEM = { value: GLOBAL_VALUE, label: 'Global (all players)' };

/** Picker rows: Global for whole-game callers, then the visible geographies (parents before children). */
export const geographyPickerItems = (mine) => {
    if (!mine) return [GLOBAL_ITEM];
    return [
        ...(mine.wholeGame ? [GLOBAL_ITEM] : []),
        ...geographyTree(mine.geographies || []).map(g => ({ value: g.id, label: g.name })),
    ];
};

/**
 * The segment that should be selected once `mine` has loaded: the current one if it is still offered,
 * else Global (null) for a whole-game caller, else the caller's first geography (null if they have none).
 * Returns `selectedSegmentId` unchanged while nothing is loaded.
 */
export const reconcileSelectedSegment = (mine, selectedSegmentId) => {
    if (!mine) return selectedSegmentId ?? null;
    const ids = geographyTree(mine.geographies || []).map(g => g.id);
    if (selectedSegmentId && ids.includes(selectedSegmentId)) return selectedSegmentId;
    if (mine.wholeGame) return null;
    return ids[0] ?? null;
};
